
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexfBlM5VhJi0hDNbMemRXsJMZ2YxnHDF3wRdtW5Rm3NvcMeta } from "/home/circleci/repo/out/apps/global-admin-panel/application/pages/index.vue?macro=true";
import { default as _91id_93mvboUGQ43dEygKV8MkuaJa019TAednPa3hVJsA4VaGsMeta } from "/home/circleci/repo/out/apps/global-admin-panel/application/pages/users/[id].vue?macro=true";
import { default as indexlHB8pl_PO9JVriS9wQD11_7cMoI7QTwVkBCalAAybWcMeta } from "/home/circleci/repo/out/apps/global-admin-panel/application/pages/login/index.vue?macro=true";
import { default as indexNvm0HyONUt6vkkj3uqRe6yYS7Zubhu_1o_f6WvgyjuoMeta } from "/home/circleci/repo/out/apps/global-admin-panel/application/pages/users/index.vue?macro=true";
import { default as index_wjk9iKbqkAqlCxR_pOr9EgSVk1UNXr21XBrdAKh1uIMeta } from "/home/circleci/repo/out/apps/global-admin-panel/application/pages/trucks/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    alias: ["/"],
    component: () => import("/home/circleci/repo/out/apps/global-admin-panel/application/pages/index.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/home/circleci/repo/out/apps/global-admin-panel/application/pages/users/[id].vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexlHB8pl_PO9JVriS9wQD11_7cMoI7QTwVkBCalAAybWcMeta || {},
    component: () => import("/home/circleci/repo/out/apps/global-admin-panel/application/pages/login/index.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/home/circleci/repo/out/apps/global-admin-panel/application/pages/users/index.vue")
  },
  {
    name: "trucks",
    path: "/trucks",
    component: () => import("/home/circleci/repo/out/apps/global-admin-panel/application/pages/trucks/index.vue")
  }
]